export * from './temp.component';
